import React from 'react';
import { translateBlockValue } from 'i18n';
import AgGridReact from 'ui/AgGridReact/AgGridReact';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import AggStatusCellRenderer from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/components/AggStatusCellRenderer';
import { useTranslation } from 'react-i18next';
import PhaseCellRenderer from 'routes/Admin/Budget/BudgetManagement/BudgetList/CellRenderers/PhaseCellRenderer';
import { DetailedDraftOperationT } from 'routes/BudgetModule/config/types';
import { StyDetailCellRenderer } from '../DetailCellRenderer/DetailCellRenderer';
import { getDraftOperationDetailColumns } from '../DetailCellRenderer/gridHelpers';

export default function DraftOperationDetailCellRenderer({
    data,
}: {
    data: DetailedDraftOperationT;
}): React.ReactElement {
    const { t } = useTranslation();
    const columns = getDraftOperationDetailColumns({ t });
    const colDefs: ColDef[] = columns.map((column) => {
        const props = {
            headerName: translateBlockValue(column.field || '', true),
            ...column,
            sortable: true,
            resizable: true,
            cellStyle: {
                display: 'flex',
                alignItems: 'center',
            },
        };
        return { key: column.field, ...props };
    });

    const onGridReady = (params: GridReadyEvent) => {
        params.api.sizeColumnsToFit();
    };

    return (
        <StyDetailCellRenderer className="ag-theme-material">
            <AgGridReact
                domLayout="autoHeight"
                rowData={data.associations}
                components={{
                    aggStatusCellRenderer: AggStatusCellRenderer,
                    phaseCellRenderer: PhaseCellRenderer,
                }}
                columnDefs={colDefs}
                rowHeight={36}
                headerHeight={36}
                rowStyle={{
                    display: 'flex',
                }}
                onGridReady={onGridReady}
            />
        </StyDetailCellRenderer>
    );
}
